export enum ContentType {
  Serie = 0,
  Episode = 1
}

export const ContentTypeLabel = new Map<number, string>([
  [ContentType.Serie, 'Série'],
  [ContentType.Episode, 'Episódio']
]);
